import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.bar {

    height: 20px;
    margin-bottom: calc(8px * 2);
    background: #eeeeee;
    position: relative;
}
.bar .marker {
    height: 100%;
    position: absolute;
}
.bar .marker.default-bg {
    background: #054c70;
}
.labels {
    display: flex;
    justify-content: space-between;
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
    font-size: 12px;
}
`;

export default styles;